export class SchoolUtil {
  static gradeNoFinished = 21 // 已经结束了
  static gradeNoBeforeSchool = 10 // 入学前
  static gradeNoGradeOne = 11
  static gradeNoDoctor = 80

  static gradeMap: { [key: number]: string } = {
    7: '小班',
    8: '中班',
    9: '大班',
    10: '入学前',
    11: '一年级',
    12: '二年级',
    13: '三年级',
    14: '四年级',
    15: '五年级',
    16: '六年级',
    17: '七年级',
    18: '八年级',
    19: '九年级',
    21: '其他年级',
    31: '高一',
    32: '高二',
    33: '高三',
    61: '大一',
    62: '大二',
    63: '大三',
    64: '大四',
    71: '研一',
    72: '研二',
    73: '研三',
    74: '研四',
    80: '博士',
  }

  // 判断是否是暑假期间，暑假期间为7月1日到8月31日
  public static get isInSummerHoliday(): boolean {
    const now = new Date()
    return now.getMonth() >= 6 && now.getMonth() <= 7
    // return now.getMonth() >= 1 && now.getMonth() <= 7
  }

  public static get gradeNos(): number[] {
    return Object.keys(this.gradeMap)
      .map((key) => parseInt(key))
      .sort((a, b) => a - b)
  }

  // 按顺序活动下一个年级
  public static getNextGradeNo(gradeNo: number): number {
    if (gradeNo === this.gradeNoFinished) {
      return this.gradeNoFinished
    }
    if (gradeNo === this.gradeNoBeforeSchool) {
      return this.gradeNoGradeOne // 入学前升1年级
    }
    if (gradeNo === this.gradeNoDoctor) {
      return this.gradeNoDoctor // 博士升博士
    }
    // 排除掉入学前, 入学前的概念需要去掉，直接用大班等正常年级
    const gradeNos: number[] = this.gradeNos.filter((item) => item !== this.gradeNoBeforeSchool)
    const idx = gradeNos.findIndex((item) => item === gradeNo)
    let result = gradeNos[idx + 1]
    if (result === this.gradeNoFinished) {
      return 31 // 初中升高中
    }
    if (!result) {
      result = 11
    }
    return result
  }

  public static get nameGradeMap(): { [key: string]: number } {
    // 对gradeMap进行key和value的互换
    const result: { [key: string]: number } = {}
    Object.keys(this.gradeMap).forEach((key) => {
      result[this.gradeMap[parseInt(key)]] = parseInt(key)
    })
    return result
  }

  public static buildGradeOptions(maxGradeNo = 80, minGradeNo = 7, grades: number[] = []) {
    const gradeNos = Object.keys(this.gradeMap).map((key) => parseInt(key))

    return gradeNos
      .filter((gradeNo) => {
        return gradeNo <= maxGradeNo && gradeNo >= minGradeNo && (!grades.length || grades.includes(gradeNo))
      })
      .map((gradeNo) => ({
        value: gradeNo,
        label: this.gradeMap[gradeNo],
      }))
  }

  public static buildClazzName(gradeNo: number, classNo: number): string {
    let gradeName = this.gradeMap[gradeNo]
    if (!gradeName) {
      gradeName = ''
    }
    return `${gradeName}(${classNo})班`
  }

  // 生成年级名称，暑假的时候特殊 如：小班(升中班)
  public static buildGradeName(
    gradeNo: number,
    options: { disabledSummerName: boolean } = {
      disabledSummerName: false,
    }
  ): string {
    let gradeName = this.gradeMap[gradeNo]
    // if (gradeNo === this.gradeNoBeforeSchool) {
    //   // 大班或者入学前
    //   gradeName = this.gradeMap[gradeNoBeforeSchool]
    // }
    if (!options.disabledSummerName && this.isInSummerHoliday) {
      if (gradeNo === 9 || gradeNo === 10) {
        gradeName = '大班/入学前'
      }
      const getNextGradeNo = this.getNextGradeNo(gradeNo)
      return `${gradeName}(升${this.gradeMap[getNextGradeNo]})`
    } else {
      return gradeName
    }
  }

  public static buildUpGradeClazzName(gradeNo: number, classNo: number): string {
    const nextGradeNo = this.getNextGradeNo(gradeNo)
    let gradeName = this.gradeMap[nextGradeNo]
    if (gradeNo === 33) {
      gradeName = '高中毕业'
    }
    if (!gradeName) {
      gradeName = ''
    }
    return `${gradeName}(${classNo})班`
  }

  // 通过已有的带有班级名称的数组，对班级名称进行排序
  public static sortItemByClazzName<T>(classNameItems: T[], nameKey: string): T[] {
    const clazzNameGradeMap = this.nameGradeMap
    return [...classNameItems].sort((a: any, b: any) =>
      clazzNameGradeMap[a[nameKey]] > clazzNameGradeMap[b[nameKey]] ? 1 : -1
    )
  }
}
